(() => {
  if (window.mfPdpReady) return;
  window.mfPdpReady = true;
  const init = () => {
    document.querySelectorAll('.mf-pdp-chart').forEach(drawer => {
      if (drawer.dataset.swipeReady) return;
      drawer.dataset.swipeReady = 'true';
      let start;
      drawer.addEventListener('touchstart', e => {
        start = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
      }, { passive: true });
      drawer.addEventListener('touchend', e => {
        if (!start || !matchMedia('(max-width: 749px)').matches) return;
        const dx = e.changedTouches[0].clientX - start.x;
        const dy = e.changedTouches[0].clientY - start.y;
        if (dx > 80 && dx > Math.abs(dy) * 1.5 && typeof drawer.hide === 'function') drawer.hide();
        start = null;
      }, { passive: true });
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', e => {
    const variant = e.detail?.variant;
    const section = e.target.closest('.shopify-section--main-product');
    if (!section) return;
    section.querySelectorAll('.mf-pdp-dispatch').forEach(el => {
      el.classList.toggle('is-unavailable', !variant?.available);
      el.querySelector('[data-mf-available]').hidden = !variant?.available;
      el.querySelector('[data-mf-unavailable]').hidden = Boolean(variant?.available);
    });
    if (!variant) return;
    const colour = (variant.option1 || variant.options?.[0] || '').toLowerCase();
    section.querySelectorAll('[data-mf-colour]').forEach(el => { el.hidden = el.dataset.mfColour !== colour; });
    init();
  });
  init();
})();

